module.exports = __webpack_public_path__ + "static/telegrotesknext-ultra-webfont-ed67d1349d17654a9dc82bb31f99c0f9.woff";